(() => {
  'use strict';
  const html=document.documentElement,store=document.getElementById('king-body-main');
  if(!store||!html.classList.contains('rs-enabled'))return;
  const desktop=matchMedia('(min-width:1000px)'),key='ebits-shop-scroll:'+location.pathname+location.search;
  let active=false,frame=0;
  const api={
    get scrollTop(){return active?store.scrollTop:window.scrollY;},
    scrollTo(...args){(active?store:window).scrollTo(...args);},
    configureAnimations(){if(window.ScrollTrigger)ScrollTrigger.defaults({scroller:active?store:window});}
  };
  window.EbitsStoreViewport=api;
  function mode(){
    const top=api.scrollTop;
    active=desktop.matches;
    html.classList.toggle('rs-viewport',active);
    api.scrollTo(0,top);
    api.configureAnimations();
    if(window.ScrollTrigger){ScrollTrigger.getAll().forEach(trigger=>{const vars={...trigger.vars,scroller:active?store:window},animation=trigger.animation;trigger.kill(false,true);ScrollTrigger.create(vars,animation);});ScrollTrigger.refresh();}
  }
  store.addEventListener('scroll',()=>{
    if(!active||frame)return;
    frame=requestAnimationFrame(()=>{frame=0;window.dispatchEvent(new Event('scroll'));});
  },{passive:true});
  function restore(){
    if(location.hash){try{document.getElementById(decodeURIComponent(location.hash.slice(1)))?.scrollIntoView();}catch{}return;}
    try{const top=Number(sessionStorage.getItem(key));if(top>0)api.scrollTo(0,top);}catch{}
  }
  window.addEventListener('pagehide',()=>{try{sessionStorage.setItem(key,String(api.scrollTop));}catch{}});
  window.addEventListener('pageshow',event=>{if(event.persisted)restore();});
  desktop.addEventListener('change',mode);
  mode();
  window.addEventListener('load',restore,{once:true});
  document.addEventListener('keydown',event=>{
    if(event.key==='Escape')document.querySelector('product-media-popup.show [data-popup-close]')?.click();
  });
})();
